import { Component, inject } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccountService } from '../../service/account.service';

@Component({
  selector: 'app-connect-vrchat',
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule],
  templateUrl: './connect-vrchat.component.html',
  styleUrl: './connect-vrchat.component.less'
})
export class ConnectVRChatComponent {
  vrchatProfileLinkControl = new FormControl('', [
    Validators.required,
    this.vrchatUrlValidator.bind(this)
  ]);

  accountService = inject(AccountService);
  private dialogRef = inject(MatDialogRef);

  pending = false;

  constructor() {
    // Mark field as touched when user starts typing for immediate validation
    this.vrchatProfileLinkControl.valueChanges.subscribe(() => {
      if (this.vrchatProfileLinkControl.dirty) {
        this.vrchatProfileLinkControl.markAsTouched();
      }
    });
  }

  private vrchatUrlValidator(control: AbstractControl) {
    const value = control.value;
    console.log('Validator called with value:', value);
    if (!value) return null;
    
    if (value.includes('https://')) {
      if (!value.startsWith('https://vrchat.com/home/user/')) {
        return { invalidVrchatUrl: true };
      }
    }
    
    console.log('Validation passed');
    return null;
  }

  getErrorMessage(): string {
    console.log('getErrorMessage called');
    console.log('Form errors:', this.vrchatProfileLinkControl.errors);
    console.log('Form invalid:', this.vrchatProfileLinkControl.invalid);
    console.log('Form touched:', this.vrchatProfileLinkControl.touched);
    
    if (this.vrchatProfileLinkControl.hasError('required')) {
      return 'VRChat profile link is required';
    }
    if (this.vrchatProfileLinkControl.hasError('invalidVrchatUrl')) {
      return 'Please enter a valid VRChat profile URL (https://vrchat.com/...) or your display name';
    }
    return '';
  }

  connectVRChat() {
    if (this.vrchatProfileLinkControl.valid) {
      if (this.vrchatProfileLinkControl.value && !this.pending) {
        this.pending = true;
        this.accountService.connectVRChat(this.vrchatProfileLinkControl.value)
          .subscribe({
            next: (data: any) => {
              if (data.code == 200) {
                this.dialogRef.close({ success: true, username: this.vrchatProfileLinkControl.value });
              } else {
                this.dialogRef.close({ success: false, message: data.message, discord_url: data.discord_url, recovery_token: data.recovery_token, username: this.vrchatProfileLinkControl.value });
              }
            },
            error: (error: any) => {
              console.error('Failed to connect VRChat:', error);
              // You could show an error message here
            }
          });
        console.log('Connecting to VRChat with profile:', this.vrchatProfileLinkControl.value);
      } else {
        throw new Error('No VRChat profile link provided');
      }
    }
  }
}
